var img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAASElEQVR42mMYBaNg8IL/8/9jA/NJ0X7+fwMaPA8ygnjtAhjiAkQagdCO3QhiDGjAKdcwYgzYD1SIHe4nxgACYDSbjYJRgB0AAK06mdEzD0c2AAAAAElFTkSuQmCC";
  export default img;